module.exports = __webpack_public_path__ + "static/conference01-d96d9fefdc516d2c393b6627acab5a31.jpg";